import { render, staticRenderFns } from "./topswiper.vue?vue&type=template&id=7f244360&scoped=true&"
import script from "./topswiper.vue?vue&type=script&lang=js&"
export * from "./topswiper.vue?vue&type=script&lang=js&"
import style0 from "./topswiper.vue?vue&type=style&index=0&id=7f244360&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f244360",
  null
  
)

export default component.exports